module.exports = __webpack_public_path__ + "assets/img/btn-back-feebf636.png";